/**
 * Change the flag icon prefix of area code select
 * @param {string} countryName - Two-letter country code (lowercase)
 * @returns {string} URL to the flag icon
 */
export function changeFlagIcon(countryName) {
  return "https://hatscripts.github.io/circle-flags/flags/" + countryName + ".svg";
}
